import useProfileCommonStore from './use-profile-common-store';
import { PROFILE_API_TYPES } from '../../hooks/api/_constants';

import {
  useProfileContractFees,
  useProfileDisclosures,
  useProfileInvestmentFacts,
  useProfileInvestmentStrategy,
  useProfileTsvInterestRate,
  useQuote
} from '../../hooks/api';
import useParticipantHoldingsStore from './use-participant-holdings-store';

const useFixedAnnuityTiaaStableValueStore = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  const apiConfigProp = { ...apiConfigBase, apiType: PROFILE_API_TYPES.prop };

  return {
    ...commonState,
    contractFees: useProfileContractFees(apiConfigProp),
    disclosureList: useProfileDisclosures({ ...apiConfigBase, forPrint: true }),
    investmentFacts: useProfileInvestmentFacts(apiConfigBase),
    investmentStrategy: useProfileInvestmentStrategy(apiConfigBase),
    participantHoldings: useParticipantHoldingsStore({ apiConfigBase, commonState }),
    quote: useQuote(apiConfigBase),
    tsvInterestRate: useProfileTsvInterestRate(apiConfigBase)
  };
};

export default useFixedAnnuityTiaaStableValueStore;
